import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
// import instance from "../myconfig";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    stepper: false,
    stepperNow: "welcome",
    page: "register",
    masterData: [],
    user: {},
    loading: false,
  },
  getters: {},
  mutations: {
    SET_MASTER_DATA(state, payload) {
      state.masterData = payload;
    },
    SET_LOADING(state) {
      state.loading = true;
    },
    SET_FINISH_LOADING(state) {
      state.loading = false;
    },
    SET_USER_DATA(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    getData({ commit }) {
      let api = process.env.VUE_APP_BASE_URL + "public/company-profile";
      axios
        .get(api)
        .then((res) => {
          const sample = {
            created_at: "2022-07-18T04:30:38+07:00",
            id: 1,
            peminjam_aktif: 13572,
            pinjaman_lunas: 614608800000,
            pinjaman_tersalurkan: 666540200000,
            tkb: 99.55,
            total_outstanding: 51931380000,
            total_peminjam: 13714,
            total_pinjamans: null,
            updated_at: "2022-07-18T04:30:38+07:00",
          };
          if (res.data.status == '00') {
            commit("SET_MASTER_DATA", res.data.data);
          } else {
            commit("SET_MASTER_DATA", sample);
          }
        })
        .catch((err) => {
          this.rollbar.debug(err);
        });
    },
    login({ commit }) {
      const loginUrl = process.env.VUE_APP_BASE_URL + "admin/login";
      const payload = {
        password: process.env.VUE_APP_BO_PASSWORD,
        username: process.env.VUE_APP_BO_USERNAME,
      }
      commit("SET_LOADING");
      return axios
        .post(loginUrl, payload)
        .then((r) => {
          if (r.data.status === '00') {
            commit('SET_USER_DATA', r.data.data)
            commit("SET_FINISH_LOADING");
          }
          commit("SET_FINISH_LOADING");
          return r;
        })
        .catch((error) => {
          commit("SET_FINISH_LOADING");
          return error;
        });
    },
    registerLpse({ commit }, payload) {
      const registerLpseUrl = process.env.VUE_APP_BASE_URL + "lpse";
      commit("SET_LOADING");
      return axios
        .post(registerLpseUrl, payload)
        .then((r) => {
          commit("SET_FINISH_LOADING");
          return r;
        })
        .catch((error) => {
          commit("SET_FINISH_LOADING");
          return error;
        });
    },
    getJobType({ commit }) {
      const getJobTypeUrl = process.env.VUE_APP_THIRD_URL + "job-type";
      commit("SET_LOADING");
      return axios
        .get(getJobTypeUrl)
        .then((r) => {
          commit("SET_FINISH_LOADING");
          return r;
        })
        .catch((error) => {
          commit("SET_FINISH_LOADING");
          return error;
        });
    },
  },
  modules: {},
});
